<script>
import canvasBase from "./CanvasBase";
import { limit, debounce } from "../../helpers/utils";
export default {
  extends: canvasBase,
  name: "canvasImage",
  props: {
    img: [HTMLImageElement, HTMLCanvasElement],
    usePixelCanvas: Number,
    bounds: Object
  },
  methods: {
    draw() {
      if (this.renderer) {
        if (this.bounds){
          this.renderer.limitDrawImgBounded(this.img, this.bounds);
          this.renderer.debounceDrawImgBounded(this.img, this.bounds);
        } else {
          this.renderer.limitDrawImg(this.img);
          this.renderer.debounceDrawImg(this.img);
        }
      }
    },
    setupDrawCall() {
      let drawCallback = this.renderer.drawImg.bind(this.renderer);
      this.renderer.limitDrawImg = limit(drawCallback, 20);
      this.renderer.debounceDrawImg = debounce(drawCallback, 50);
      
      let boundedDrawCallback = this.renderer.drawImgBounded.bind(this.renderer);
      this.renderer.limitDrawImgBounded = limit(boundedDrawCallback, 20);
      this.renderer.debounceDrawImgBounded = debounce(boundedDrawCallback, 50);
    }
  },
  watch: {
    img() {
      if (this.autodraw) this.redraw();
      if (!this.img) this.renderer.clear();
    },
    usePixelCanvas() {
      if (this.autodraw) this.redraw();
    }
  }
};
</script>
